/**
 * Compute the bounding box of all content inside an element (including absolutely positioned children).
 * Returns width and height so the printable container can be given dimensions in the print document.
 */
function getContentBounds(el: HTMLElement): { width: number; height: number } {
  const rect = el.getBoundingClientRect();
  let maxRight = 0;
  let maxBottom = 0;

  function walk(node: HTMLElement) {
    if (node.nodeType !== 1) return;
    const r = node.getBoundingClientRect();
    const right = r.right - rect.left;
    const bottom = r.bottom - rect.top;
    if (right > maxRight) maxRight = right;
    if (bottom > maxBottom) maxBottom = bottom;
    for (let i = 0; i < node.children.length; i++) {
      walk(node.children[i] as HTMLElement);
    }
  }

  walk(el);
  return {
    width: Math.max(maxRight, 1),
    height: Math.max(maxBottom, 1),
  };
}

export const printDatasheet = ({
  printableElement,
  pixelsToSkip,
}: {
  printableElement: HTMLDivElement;
  pixelsToSkip?: number;
}) => {
  const getCurrentStyles = () => {
    const head = document.getElementsByTagName("head")[0];

    let styles = "";

    const styleNodeName = "STYLE";

    if (head) {
      for (let i = 0; i < head.childNodes.length; i++) {
        const node = head.childNodes[i] as HTMLDivElement;

        if (styleNodeName == node.nodeName) {
          styles = styles + "\n" + (head.childNodes[i] as HTMLDivElement).innerHTML;
        }
      }
    }

    return styles + "\n";
  };

  const bounds = getContentBounds(printableElement);
  const printContainerStyle = `
    .DatasheetsResultDatasheet {
      min-width: ${bounds.width}px !important;
      min-height: ${bounds.height}px !important;
    }
  `;

  const printableContent = `
              <html>
              <head>
                  <style>
                      ${getCurrentStyles()}
                      ${printContainerStyle}
                  </style>
              </head>
              <body onload='setTimeout(function(){window.print();}, 500);'  style='overflow: visible; margin-left:-${
                pixelsToSkip || 0
              }px;'>
                 ${printableElement.outerHTML}
              </body>
              </html>
            `;

  var printingWindow = window.open("", "_blank", "width=900px, height=600px, resizable");
  var doc = (printingWindow as Window).document;

  doc.open();
  doc.write(printableContent);
  doc.close();
};
